import { render, staticRenderFns } from "./personalcualificado-form.vue?vue&type=template&id=3705a36f&scoped=true"
import script from "./personalcualificado-form.vue?vue&type=script&lang=js"
export * from "./personalcualificado-form.vue?vue&type=script&lang=js"
import style0 from "./personalcualificado-form.vue?vue&type=style&index=0&id=3705a36f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3705a36f",
  null
  
)

export default component.exports